import { createContext, useContext } from "react";

/**
 * Shared context for ARC connection
 * Used by both ARCProvider (fleet mode) and SingleARCProvider (arc mode)
 */
export const ARCContext = createContext();
ARCContext.displayName = "ARC";

/**
 * Hook to access ARC context
 * Provides: controlSocket, connectionState, sendCommand, callService, selectedARC, selectARC, selectedARCSerial, arcStatus
 */
export const useARC = () => useContext(ARCContext);
